import { Card, Tooltip, Typography } from '@mui/material'

// import { getAttachment } from '@/api/maintenance-tickets-api'
import ImageIcon from '@/assets/icons/image-icon.png'
import Mp4Logo from '@/assets/icons/mp4.png'
import PdfLogo from '@/assets/icons/pdf.png'
import { useOpenAttachment } from '@/utilities'

import ExcelIcon from '@/assets/icons/excel-icon.png'

interface CustomMediaCardProps {
  src: string
  attachmentNumber: string
  attachmentType: string
  attachmentName: string
  cardWidth: {
    xs: number | string
    sm: number | string
    md: number | string
  }
  cardMaxHeight: {
    xs: number | string
    sm: number | string
    md: number | string
  }
  imageMaxHeight: number | string
  cardMinHeight: number | string
}

const CustomImageCard = ({
  src,
  attachmentNumber,
  attachmentName,
  attachmentType,
  cardWidth,
  cardMaxHeight,
  imageMaxHeight,
  cardMinHeight,
}: CustomMediaCardProps) => {
  const openAttachment = useOpenAttachment()

const getFileLogo = (type: string, src: string) => {
  console.log('TYPE', type)
  if (type.startsWith('image/')) {
    return ImageIcon
  }

  switch (type) {
    case 'application/pdf':
      return PdfLogo
    case 'video/mp4':
      return Mp4Logo
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.ms-excel':
      return ExcelIcon 
    default:
      return src
  }
}
  const handleClick = async () => {
    await openAttachment(attachmentName)
  }

  return (
    <Card
      sx={{
        width: cardWidth,
        maxHeight: cardMaxHeight,
        minHeight: cardMinHeight,
        paddingLeft: '5px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '0.8rem',
        gap: 1,
        cursor: 'pointer',
        transition: '0.2s',
        border: 'none',
        boxShadow: 'none',
      }}
      onClick={() => void handleClick()}
    >
      <img
        src={getFileLogo(attachmentType, src)}
        alt="Attachment"
        onError={(event) => {
          const target = event.target as HTMLImageElement
          target.style.width = '60%'
          target.style.height = '100px'
          target.style.objectFit = 'contain'
        }}
        style={{
          width: '15%',
          minWidth: '15%',
          height: 'auto',
          maxHeight: imageMaxHeight,
          objectFit: 'contain',
        }}
      />
      <Tooltip title={attachmentName} arrow>
        <Typography
          marginTop={1}
          gutterBottom
          textAlign="center"
          component="div"
          sx={{
            fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.7rem' },
            maxWidth: '120px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            cursor: 'pointer',
          }}
        >
          {attachmentNumber}
        </Typography>
      </Tooltip>
    </Card>
  )
}

export default CustomImageCard
